import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thumbnails", "previews", "previewModal"]
  static values = {
    current: Number,
    total: Number
  }

  changeImage(e) {
    this.currentValue = e.target.dataset.index
    this.#updatePreviews()
  }

  prev(e) {
    e.stopPropagation()
    this.currentValue--
    if (this.currentValue <= 0) this.currentValue = this.totalValue - 1
    this.#updatePreviews()
  }

  next(e) {
    e.stopPropagation()
    this.currentValue++
    if (this.currentValue >= this.totalValue) this.currentValue = 0
    this.#updatePreviews()
  }

  openPreview() {
    this.previewModalTarget.classList.remove("hidden")
  }

  closePreview() {
    this.previewModalTarget.classList.add("hidden")
  }

  #updatePreviews() {
    this.previewsTargets.forEach((preview) => {
      preview.src = this.thumbnailsTargets[this.currentValue].src
    })
  }
}
